import barra from "../../general/barra/barra.vue";
import barrais from "../../general/barrais/barrais.vue";
import foot from "../../general/foot/foot.vue";
import barrade from "../../general/barrade/barrade.vue";
import mixx from "../../../mixin/mixin.js";

export default {
  mixins: [mixx],
  name: "cuponesLiquidados",
  data() {
    return {
      msg: "-",
      loading: false,
      tbv: null,
      f_c: {
        desde: this.date_rest(this.currentdate(), -10),
        hasta: this.currentdate(),
        estado: false
      }
    };
  },
  mounted() {
    $("#cont_r").css("min-height", window.innerHeight - 101 + "px");
    this.tbv = $("#ventas").DataTable({
      paging: true,
      lengthChange: true,
      searching: true,
      ordering: true,
      info: true,
      order: [],
      autoWidth: true,
      orderCellsTop: true,
      fixedHeader: true,
      rowCallback: function(row, data, index) {}
    });
    $(".box").boxWidget();
  },
  components: {
    barra,
    barrais,
    foot,
    barrade
  },
  computed: {
    reporte: function() {
      return (
        "/billeteras/gocuotas/sucursales/ventas?desde=" +
        this.f_c.desde +
        "&hasta=" +
        this.f_c.hasta +
        "&estado=" +
        this.f_c.estado
      );
    }
  },
  methods: {
    consultar() {
      this.loading = true;
      this.tbv.clear();
      this.$http
        .post("/billeteras/gocuotas/sucursales/ventas", this.f_c)
        .then(response => {
          response.data.data.forEach(element => {
            element[3] = this.num_to_many(element[3]);
            this.tbv.row.add(element);
          });
          this.tbv.draw();
          this.loading = false;
        });
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/reportes/goCuotasVentasSuc/index.js